import React from 'react';
import { Typography } from '@mui/material';
import { useCity } from '../contexts/CityContext';

/**
 * Component for displaying prices in the correct currency format
 * based on the selected city in CityContext
 */
const PriceDisplay = ({ 
  price, 
  variant = 'body1', 
  component = 'span',
  color = 'inherit',
  sx = {},
  symbolBefore = false, // For USD typically we show $ before the price
  ...props 
}) => {
  const { currentCity, convertPrice } = useCity();
  
  // Convert price to the current city's currency
  const formattedPrice = convertPrice(price);
  
  // Format based on currency style
  let displayPrice;
  
  if (currentCity.currency === 'USD' && symbolBefore) {
    // For USD with symbol before: $10.99
    displayPrice = `${currentCity.currencySymbol}${formattedPrice}`;
  } else {
    // For EUR and others with symbol after: 10,99€
    displayPrice = `${formattedPrice}${currentCity.currencySymbol}`;
  }
  
  return (
    <Typography variant={variant} component={component} color={color} sx={sx} {...props}>
      {displayPrice}
    </Typography>
  );
};

export default PriceDisplay; 